<template>
  <div>
    <div class="row">
      <div class="col-8">
        <title-breadcrumb :page="page" />
      </div>
      <div class="col-4" />
    </div>

    <div class="row pt-3">
      <div class="col-12">
        <filter-location />
      </div>
    </div>

    <custom-separator text="Resultados" class="pt-3" />

    <RowCardItemCard
      v-for="result in results"
      :key="result.id"
      :status="result.status"
      :status-class="result.statusColor"
    >
      <!-- Informacion que acompañana al estado -->
      <div slot="statusInfo">
        <div class="d-flex flex-column">
          <span class="data-title">Nombre del Solicitante</span>
          <span class="data-content">{{ result.requestingName }}</span>
        </div>
      </div>
      <!-- Cuerpo de la Card -->
      <div slot="body">
        <div class="col-12 p-0 mx-4 d-flex">
          <div class="col-4 p-0">
            <div class="d-flex flex-column">
              <span class="data-title">Número de Solicitante:</span>
              <span class="data-content">{{ result.requestingNumber }}</span>
            </div>
          </div>
          <div class="col-4 p-0">
            <div class="d-flex flex-column">
              <span class="data-title">SIE:</span>
              <span class="data-content">{{ result.sieNumber }}</span>
            </div>
          </div>
          <div class="col-4 p-0">
            <div class="d-flex flex-column">
              <span class="data-title">Fecha:</span>
              <span class="data-content">{{ result.date }}</span>
            </div>
          </div>
        </div>
        <div class="col-12 p-0 mx-4 my-4 d-flex">
          <div class="col-4 p-0">
            <div class="d-flex flex-column">
              <span class="data-title">Número de Referido:</span>
              <span class="data-content">{{ result.referralNumber }}</span>
            </div>
          </div>
          <div class="col-4 p-0">
            <div class="d-flex flex-column">
              <span class="data-title">CAAT:</span>
              <span class="data-content">{{ result.caat }}</span>
            </div>
          </div>
          <div class="col-4 p-0">
            <div class="d-flex flex-column">
              <span class="data-title">Tipo:</span>
              <span class="data-content">{{ result.type }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Acciones -->
      <div v-if="result.status == status.REALIZADO" slot="actions">
        <div class="dropdown text-right">
          <button
            class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="px-2">Acciones</span>
            <i class="fa fa-angle-down" />
          </button>
          <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
            <div class="dropdown-item">
              <em class="fas fa-download text-green pr-1" />
              <span>Documentos</span>
            </div>
            <div class="border-top my-1 mx-2" />
            <div class="dropdown-item ">
              <em class="fas fa-search-plus text-green pr-1" />
              <span>Discusión de Evaluación</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="result.status == status.PENDIENTE_DE_AVALUO" slot="actions">
        <div class="dropdown text-right">
          <button
            class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="px-2">Acciones</span>
            <i class="fa fa-angle-down" />
          </button>
          <div class="dropdown-menu dropdown-menu-right px-4 py-2 mt-1">
            <div class="dropdown-item">
              <em class="fas fa-download text-green" />
              <span>Documentos</span>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="result.status == status.PENDIENTE_DE_DISCUSION_DE_ESCUELA"
        slot="actions"
      >
        <div class="dropdown text-right">
          <button
            class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="px-2">Acciones</span>
            <i class="fa fa-angle-down" />
          </button>
          <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
            <div class="dropdown-item">
              <em class="fas fa-download text-green pr-1" />
              <span>Documentos</span>
            </div>
            <div class="dropdown-item ">
              <em class="fas fa-file-invoice text-green pr-1" />
              <span>Ver Referido de Solicitud</span>
            </div>
            <div class="border-top my-1 mx-2" />
            <div class="dropdown-item ">
              <em class="fas fa-search-plus text-green pr-1" />
              <span>Discusión de la Evaluación</span>
            </div>
            <div class="dropdown-item ">
              <em class="fas fa-book-reader text-green pr-1" />
              <span>Discusión en la Escuela</span>
            </div>
            <div class="border-top my-1 mx-2" />
            <div class="dropdown-item " @click="openAttachDocuments(result.id)">
              <em class="fas fa-plus-circle text-green pr-1" />
              <span>Anejar Documentos de Entrega de Equipo</span>
            </div>
          </div>
        </div>
      </div>
      <div v-if="result.statusInfo" slot="extra">
        <div class="col-12 expanded-card p-2">
          <div class="col-12 expanded-content p-4">
            <i class="fas fa-info-circle text-orange mr-2" />
            <span>Información del Estatus</span>
            <div class="col-12 d-flex justify-content-between">
              <div class="col-3">
                <span class="data-title">
                  Región:
                  <br />
                </span>
                <span class="data-content">{{ result.statusInfo.region }}</span>
              </div>
              <div class="col-3">
                <span class="data-title">
                  Municipio:
                  <br />
                </span>
                <span class="data-content">
                  {{ result.statusInfo.municipality }}
                </span>
              </div>
              <div class="col-3">
                <span class="data-title">
                  Escuela:
                  <br />
                </span>
                <span class="data-content">{{ result.statusInfo.school }}</span>
              </div>
              <div class="col-3">
                <span class="data-title">
                  Razón:
                  <br />
                </span>
                <span class="data-content">{{ result.statusInfo.reason }}</span>
              </div>
            </div>
            <div class="col-12 px-4 mt-4">
              <div class="col-3 p-0">
                <span class="data-title">
                  Comentario:
                  <br />
                </span>
              </div>
            </div>
            <div class="col-12 px-4 py-2">
              <div class="col-10 p-0">
                <span class="data-content">
                  {{ result.statusInfo.comment }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="canShowAttachDocument(result.id)" slot="dynamicExtra">
        <div class="col-12 expanded-card p-2 d-flex justify-content-between">
          <div class="col-12 expanded-content p-4">
            <section-title
              content="Añadir Documento"
              icon="fas fa-file-plus"
              reverse
              bg-icon="green"
            />
            <div class="col-12 d-flex justify-content-between">
              <div class="col-4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="tipo de dni"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="selectedDocumentType"
                    fieldname="type"
                    fieldkey="id"
                    :options="documentTypes"
                    placeholder="Seleccione"
                    label="Documento:"
                    :error="errors[0]"
                    :custom-error-msg.sync="errors[0]"
                  />
                </ValidationProvider>
              </div>
              <div class="col-4">
                <custom-file-input
                  ref="attachedDocument"
                  v-model="selectedDocument"
                  label="Archivo:"
                  label-position="left"
                  :accept="allowedFiles"
                  required
                  display-style="normal"
                />
              </div>
              <div
                class="col-4 d-flex align-items-end justify-content-end p-0 "
              >
                <div class="text-right">
                  <ActionButton
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger ml-2"
                    @click="saveDocument(result.id)"
                  >
                    Cancelar
                  </ActionButton>
                  <ActionButton
                    variant="success ml-2 m-0  px-4"
                    type="submit"
                    @click="saveDocument(result.id)"
                  >
                    Guardar
                  </ActionButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </RowCardItemCard>

    <pagination />
  </div>
</template>

<script>
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import FilterLocation from '@/components/student/FilterLocation';
import CustomSeparator from '@/components/common/CustomSeparator';
import RowCardItemCard from '@/components/common/rowcard/RowCardItemCard';
import Pagination from '@/components/common/Pagination.vue';
import CustomFileInput from '@/components/common/CustomFileInput.vue';
import SectionTitle from '@/components/pei/shared/SectionTitle.vue';
import CustomDropDown from '@/components/common/CustomDropDown.vue';
import { ActionButton } from '@/components/common';

export default {
  name: 'InforTechAssistanceReferrals',
  components: {
    TitleBreadcrumb,
    FilterLocation,
    CustomSeparator,
    RowCardItemCard,
    Pagination,
    CustomFileInput,
    SectionTitle,
    CustomDropDown,
    ActionButton,
  },
  props: {
    item: {
      type: Object,
      default: () => ({
        region: '',
        distrit: '',
        school: '',
        name: '',
        PEI: '',
        SIE: '',
        terapy: '',
      }),
    },
  },
  data: () => ({
    page: {
      icon: 'fas fa-user-circle',
      title: 'Información de Referidos de Asistencia Tecnológica',
      routes: [
        'Inicio',
        'Estudiante',
        'Información de Referidos de Asistencia Tecnológica',
      ],
    },
    editing: false,
    maxlength: 500,
    isAttachingDocument: false,
    selectedDocument: null,
    allowedFiles: '.pdf',
    documentTypes: [],
    selectedDocumentType: null,
    showAttachDocument: [],
    status: {
      AJUSTADO: 'ajustado',
      SERVIDO: 'servido',
      DENEGADO: 'denegado',
      PENDIENTE_DE_AVALUO: 'Pendiente de Avalúo',
      PENDIENTE_DE_EVALUACION: 'Pendiente de evaluación',
      PENDIENTE_DE_DISCUSION_DE_ESCUELA: 'Pendiente de Discusión Escuela',
      REALIZADO: 'Realizado',
    },
    results: [
      {
        id: 0,
        status: 'Realizado',
        statusColor: 'green',
        requestingName: 'Alejandra Moreno Cruz',
        requestingNumber: '2015013825',
        sieNumber: '24554799',
        date: '17/ene./2020',
        referralNumber: '2020-01-0822',
        caat: 'Caguas',
        type: 'Regular',
        statusInfo: undefined,
      },
      {
        id: 1,
        status: 'Pendiente de Avalúo',
        statusColor: 'yellow',
        requestingName: 'Rafael Fabriel Roman Hernandez',
        requestingNumber: '0000223772 ',
        sieNumber: '24277623',
        date: '16/ene./2020',
        referralNumber: '2020-01-0824',
        caat: 'Bayamón',
        type: 'Avalúo',
        statusInfo: undefined,
      },
      {
        id: 2,
        status: 'Pendiente de Discusión Escuela',
        statusColor: 'yellow',
        requestingName: 'Hunter Y Muñiz Rivas',
        requestingNumber: '2015002669',
        sieNumber: '24541260',
        date: '24/ene./2020',
        referralNumber: '2020-01-0825',
        caat: 'bayamón',
        type: 'Solicitud de Servicio Relacionada a un equipo',
        statusInfo: undefined,
      },
      {
        id: 3,
        status: 'Pendiente de Discusión Escuela',
        statusColor: 'yellow',
        requestingName: 'Hunter Y Muñiz Rivas',
        requestingNumber: '2015002669',
        sieNumber: '24541260',
        date: '24/ene./2020',
        referralNumber: '2020-01-0825',
        caat: 'bayamón',
        type: 'Solicitud de Servicio Relacionada a un equipo',
        statusInfo: undefined,
      },
      {
        id: 4,
        status: 'Denegado',
        statusColor: 'brown',
        requestingName: 'Keirilis Paola Astacio Lopez',
        requestingNumber: '2019013454',
        sieNumber: '24722432',
        date: '28/ene./2020',
        referralNumber: '2020-01-0825',
        caat: 'Mayaguez',
        type: 'Regular',
        statusInfo: {
          region: 'Mayaguez',
          municipality: 'Cabo',
          school: 'HO055 - Cabo Rojo - Hogar',
          reason: 'General',
          comment:
            'Hemos recibido una guía de referido solicitando evaluación en Asistencia Tecnológica (AT). Este referido no puede ser procesado debido a que para procesar esta solicitud se requiere de la provisión de los siguientes documentos y/o se considere el cumplimiento de las siguientes especificaciones: 1. Según de informa en el referido de AT el estudiante no requiere la evaluación de AT en estos momentos. El referido se genera debido a una enmienda que se está realizando al PEI.',
        },
      },
    ],
  }),
  methods: {
    onEditRow() {
      this.editing = !this.editing;
    },
    openAttachDocuments(id) {
      if (id != null) {
        this.showAttachDocument.push(id);
      }
    },
    saveDocument(id) {
      if (id != null) {
        let AttachDocumentIndex = this.showAttachDocument.findIndex(
          (e) => e === id
        );
        this.showAttachDocument.splice(AttachDocumentIndex, 1);
      }
    },
    canShowAttachDocument(id) {
      if (id != null) {
        return this.showAttachDocument.indexOf(id) >= 0;
      }
    },
  },
};
</script>

<style scoped>
.icon-position {
  max-width: 6%;
  padding-top: 35px;
  text-align: center;
}
.force-orange {
  color: #ff7058;
}
.text-gray-l {
  color: #3f5b60;
}
.text-gray {
  color: #727272;
}
.text-black {
  color: #11291b;
}
.divider-horizontal {
  border-right: 1px solid #e2e2e2;
}
.col-3-alt {
  max-width: 20%;
}
.shadow-icon {
  color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 50px;
  width: 34px;
}
.expanded-card {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
.expanded-content {
  background: #ffffff 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}
.btn-dropdown-actions i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
.btn-dropdown-actions::after {
  border: none;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-size: 15px;
}
.dropdown-item span {
  margin-left: 10px;
}
.dropdown-item em {
  min-width: 23px;
}
</style>
